import React, { Component } from 'react'
import '../styles/ThemesCart.css'
import LAIcon from '../images/Themes/icon-small-la.png'
import VBNIcon from '../images/Themes/icon-small-vbn.png'
import AbattoirIcon from '../images/Themes/icon-small-abattoir.png'
import YakuzaIcon from '../images/Themes/icon-small-yakuza.png'
import TombeauIcon from '../images/Themes/icon-small-tombeau.png'
import EditIcon from '../images/Booking/pen.png'
import DeleteIcon from '../images/Booking/cross.png'
import CupCake from '../images/Booking/cupcake.png'
import MarkerIcon from '../images/Booking/marker.png'
import CalendarIcon from '../images/Booking/calendar-blue.png'
import PlayerIcon from '../images/Booking/player-icon.png'
import GlobeIcon from '../images/Booking/globe.png'
import BirthdayCake from '../images/Booking/gateau-anniversaire.png'
import PopIn from './PopIn'
import { API_ROOT } from '../api-config'
import { Cookies } from 'react-cookie-banner'
import { injectIntl, defineMessages } from "react-intl"
import axios from 'axios'
import { cartCookieOptions, safeBookingsForCookie } from './CartCookieStorage'

const themeIconConverter = (theme) => {
  switch (theme) {
    case 'la':
      return LAIcon
    case 'vbn':
      return VBNIcon
    case 'abattoir':
      return AbattoirIcon
    case 'yakuza':
      return YakuzaIcon
    case 'tombeau':
      return TombeauIcon
    default:
      break
  }
}

const getMappedRoomId = (roomIdsByTheme, theme, fallbackId) => {
  const mappedId = roomIdsByTheme && roomIdsByTheme[theme]
  return `${mappedId || fallbackId}`
}

const normalizeText = (value) => `${value || ''}`.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

const normalizeRoomId = (roomId) => {
  switch (`${roomId || ''}`) {
    case '1':
      return '27'
    case '2':
      return '28'
    case '5':
      return '29'
    case '6':
      return '31'
    case '4':
      return '32'
    default:
      return `${roomId || ''}`
  }
}

const normalizeTheme = (theme) => {
  const rawTheme = `${theme || ''}`
  return ['la', 'vbn', 'abattoir', 'yakuza', 'tombeau'].indexOf(rawTheme) !== -1 ? rawTheme : ''
}

const getThemeFromRoomName = (value) => {
  const name = normalizeText(value)
  if (name.indexOf('very bad') !== -1 || name.indexOf('vbn') !== -1) return 'vbn'
  if (name.indexOf('lost') !== -1) return 'la'
  if (name.indexOf('abattoir') !== -1) return 'abattoir'
  if (name.indexOf('yakuza') !== -1) return 'yakuza'
  if (name.indexOf('expedition') !== -1 || name.indexOf('maudite') !== -1 || name.indexOf('tombeau') !== -1) return 'tombeau'
  return ''
}

const getThemeFromRoomId = (roomId, roomIdsByTheme = {}) => {
  const explicitTheme = normalizeTheme(roomId)
  if (explicitTheme) return explicitTheme

  const rawRoomId = `${roomId || ''}`
  const nameTheme = getThemeFromRoomName(rawRoomId)
  if (nameTheme) return nameTheme

  const normalizedRoomId = normalizeRoomId(rawRoomId)
  const mappedTheme = Object.keys(roomIdsByTheme || {}).find((theme) => {
    const mappedRoomId = `${roomIdsByTheme[theme]}`
    return mappedRoomId === rawRoomId || normalizeRoomId(mappedRoomId) === normalizedRoomId
  })
  if (mappedTheme) return mappedTheme

  switch (normalizedRoomId) {
    case '27':
      return 'la'
    case '28':
      return 'vbn'
    case '29':
      return 'abattoir'
    case '31':
      return 'yakuza'
    case '32':
      return 'tombeau'
    default:
      return ''
  }
}

const getRoomIdForTheme = (theme, roomIdsByTheme = {}) => {
  switch (theme) {
    case 'la':
      return getMappedRoomId(roomIdsByTheme, 'la', 27)
    case 'vbn':
      return getMappedRoomId(roomIdsByTheme, 'vbn', 28)
    case 'abattoir':
      return getMappedRoomId(roomIdsByTheme, 'abattoir', 29)
    case 'yakuza':
      return getMappedRoomId(roomIdsByTheme, 'yakuza', 31)
    case 'tombeau':
      return getMappedRoomId(roomIdsByTheme, 'tombeau', 32)
    default:
      return ''
  }
}

const getLocalRoomIdForTheme = (theme) => {
  switch (theme) {
    case 'la':
      return '1'
    case 'vbn':
      return '2'
    case 'abattoir':
      return '5'
    case 'yakuza':
      return '6'
    case 'tombeau':
      return '4'
    default:
      return ''
  }
}

const formatDateWithZero = (date) => {
  const formattedDate = date.split("-")
  let y, M, d

  y = formattedDate[0]
  M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
  d = formattedDate[2].length < 2 ? `0${formattedDate[2]}` : formattedDate[2]

  return `${d}/${M}/${y}`
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

const buildAPI_URL_Booking = (idReservation, tokenReservation) => {
  return `${API_ROOT}FrontGetReservationDetails.php?id_reservation=${idReservation}&token_reservation=${tokenReservation}`
}

const formatPrice = (price) => {
  const numericPrice = parseFloat(price || 0)
  return {
    euros: Math.floor(numericPrice),
    cents: (Math.round((numericPrice % 1) * 100) / 100).toFixed(2).split(".")[1]
  }
}

const toPriceNumber = (price) => {
  const numericPrice = parseFloat(price)
  return Number.isFinite(numericPrice) ? numericPrice : 0
}

const getOptionPrice = (fallbackPrice, prices) => {
  const foundPrice = prices.find((price) => parseFloat(price || 0) > 0)
  return foundPrice || fallbackPrice
}

const normalizeSelectedRoomOption = (option) => {
  if (!option) return null
  const id = option.id || option.id_room_option || option.room_option_id || option.id_room_option_selected
  if (!id) return null

  return {
    ...option,
    id: id,
    id_room_option: id,
    name: option.name || option.room_option_name,
    room_option_name: option.room_option_name || option.name,
    description: option.description || option.room_option_description,
    room_option_description: option.room_option_description || option.description,
    price: option.price || option.room_option_price || option.room_option_price_without_promo
  }
}

const getSlotSelectedOptions = (slot) => {
  if (!slot) return []
  if (Array.isArray(slot.room_options)) {
    return slot.room_options.map(normalizeSelectedRoomOption).filter((option) => option && option.id)
  }
  if (slot.room_option_name || (slot.id_room_option && `${slot.id_room_option}` !== '0')) {
    const normalizedOption = normalizeSelectedRoomOption({
      id: slot.id_room_option,
      name: slot.room_option_name,
      description: slot.room_option_description,
      price: getOptionPrice(0, [
        slot.room_option_price_without_promo,
        slot.room_option_price
      ])
    })
    return normalizedOption ? [normalizedOption] : []
  }
  return []
}

const getSlotSelectedOptionIds = (slot) => getSlotSelectedOptions(slot).map((option) => `${option.id}`)

const hasSelectedRoomOption = (slot) => getSlotSelectedOptions(slot).length > 0

const getBirthdayFirstnameFromComment = (comment) => {
  if (!comment) return ''
  const match = `${comment}`.match(/(?:Prénom option anniversaire[^:\r\n]*|Anniversaire)\s*:\s*([^\r\n]+)/i)
  return match ? match[1].trim() : ''
}

const isVideoPackOption = (option) => {
  if (!option) return false
  const optionText = `${option.name || option.room_option_name || ''} ${option.description || option.room_option_description || ''}`.toLowerCase()
  return optionText.indexOf('pack') !== -1 && optionText.indexOf('vid') !== -1
}

const isBirthdayOption = (option, theme) => {
  if (!option) return false
  const optionName = normalizeText(option.name || option.room_option_name || '')
  const optionText = `${option.name || option.room_option_name || ''} ${option.description || option.room_option_description || ''}`.toLowerCase()
  const optionPrice = parseFloat(option.price || option.room_option_price || option.room_option_price_without_promo || 0)
  if (optionName.indexOf('personnalis') !== -1 || optionName.indexOf('custom') !== -1 || Math.abs(optionPrice - 50) < 0.01) return false
  if ((optionText.indexOf('anniversaire') !== -1 || optionText.indexOf('birthday') !== -1) && theme !== 'vbn') return true
  return Math.abs(optionPrice - 15) < 0.01
    && optionText.indexOf('personnalis') === -1
    && optionText.indexOf('pack') === -1
    && optionText.indexOf('vid') === -1
}

const isVbnPersonalizationOption = (option) => {
  if (!option) return false
  const optionName = normalizeText(option.name || option.room_option_name || '')
  const optionText = normalizeText(`${option.name || option.room_option_name || ''} ${option.description || option.room_option_description || ''}`)
  const optionPrice = parseFloat(option.price || option.room_option_price || option.room_option_price_without_promo || 0)
  const hasPersonalizationText = optionName.indexOf('personnalis') !== -1 || optionName.indexOf('custom') !== -1
  return (hasPersonalizationText || Math.abs(optionPrice - 50) < 0.01)
      && optionName.indexOf('anniversaire') === -1
      && optionName.indexOf('birthday') === -1
      && optionText.indexOf('video') === -1
      && optionText.indexOf('vid') === -1
}

const getOptionType = (option, roomId, roomIdsByTheme = {}) => {
  const roomTheme = getThemeFromRoomId(roomId, roomIdsByTheme)
  if (isVideoPackOption(option)) return 'video'
  if (roomTheme === 'vbn' && isVbnPersonalizationOption(option)) return 'vbn'
  if (isBirthdayOption(option, roomTheme)) return 'birthday'
  return ''
}

const getBirthdayOptionVariant = (roomId, roomIdsByTheme = {}) => {
  return getThemeFromRoomId(roomId, roomIdsByTheme) === 'abattoir' ? 'abattoir' : 'lost-asylum'
}

const getSlotRoomId = (slot) => {
  if (!slot) return ''
  if (typeof slot === 'string') {
    const slotParts = slot.split('|')
    return slotParts[5] || ''
  }

  const roomId = slot.room_id
    || slot.id_room
    || slot.id_room_escape
    || slot.id_room_enigma
    || slot.roomId
    || slot.idRoom
    || slot.room_id_escape
    || ''

  if (roomId) return roomId

  return /^\d+$/.test(`${slot.room || ''}`) ? slot.room : ''
}

const getSlotFallbackName = (slot = {}) => {
  if (!slot || typeof slot === 'string') return ''
  return slot.room_name
    || slot.roomname
    || slot.enigma_name
    || slot.name_enigma
    || slot.theme_name
    || slot.room_label
    || slot.label
    || slot.name
    || ''
}

const getSlotTheme = (slot, roomIdsByTheme = {}) => {
  if (!slot) return ''
  if (typeof slot === 'string') {
    const slotTheme = slot.split('|')[0] || ''
    return normalizeTheme(slotTheme) || getThemeFromRoomId(slotTheme, roomIdsByTheme)
  }

  const rawTheme = `${slot.room || slot.theme || ''}`
  if (['la', 'vbn', 'abattoir', 'yakuza', 'tombeau'].indexOf(rawTheme) > -1) {
    return rawTheme
  }

  return getThemeFromRoomName(`${slot.room_name || ''} ${slot.roomname || ''} ${slot.enigma_name || ''} ${slot.name_enigma || ''} ${slot.name || ''} ${slot.room || ''} ${slot.theme || ''}`)
    || getThemeFromRoomId(getSlotRoomId(slot), roomIdsByTheme)
}

const getSlotReservationDate = (slot) => {
  if (!slot) return ''
  if (typeof slot === 'string') return slot.split('|')[1] || ''
  return slot.reservation_date
    || slot.reservationDate
    || slot.date
    || slot.reservation_day
    || slot.day
    || ''
}

const getResolvedSlotRoomId = (slot, roomIdsByTheme = {}) => {
  const roomId = getSlotRoomId(slot)
  if (roomId && getThemeFromRoomId(roomId, roomIdsByTheme)) return `${roomId}`

  return getRoomIdForTheme(getSlotTheme(slot, roomIdsByTheme), roomIdsByTheme) || `${roomId || ''}`
}

const isOptionActive = (option) => {
  if (!option) return false
  if (option.active === 0 || option.active === '0' || option.active === false) return false

  const optionText = `${option.description || option.room_option_description || ''}`.toLowerCase()
  return optionText.indexOf('[onehour-option-inactive]') === -1
}

const getRoomOptionsForDisplay = (roomId, options, reservationDate, roomIdsByTheme = {}) => {
  if (!options || options.length === 0) return []
  const activeOptions = options.filter(isOptionActive)
  if (activeOptions.length === 0) return []
  const roomTheme = getThemeFromRoomId(roomId, roomIdsByTheme)

  return activeOptions.filter((option) => {
    const optionType = getOptionType(option, roomId, roomIdsByTheme)
    if (optionType === 'video') return roomTheme === 'la' || roomTheme === 'abattoir' || roomTheme === 'tombeau'
    if (optionType === 'birthday') {
      return roomTheme === 'la' || roomTheme === 'abattoir'
    }
    if (optionType === 'vbn') {
      return roomTheme === 'vbn' && isMoreThanThreeDaysAway(reservationDate)
    }
    return false
  })
}

const getOptionsForSlot = (slot, optionsByRoom = {}, roomIdsByTheme = {}) => {
  const slotTheme = getSlotTheme(slot, roomIdsByTheme)
  const roomId = getResolvedSlotRoomId(slot, roomIdsByTheme)
  const mappedRoomId = getRoomIdForTheme(slotTheme, roomIdsByTheme)
  const localRoomId = getLocalRoomIdForTheme(slotTheme)
  const possibleRoomIds = [
    getSlotRoomId(slot),
    roomId,
    normalizeRoomId(roomId),
    mappedRoomId,
    normalizeRoomId(mappedRoomId),
    localRoomId,
    normalizeRoomId(localRoomId)
  ].filter((id, index, ids) => id && ids.indexOf(id) === index)

  const roomOptions = possibleRoomIds
    .map((id) => optionsByRoom[id] || optionsByRoom[parseInt(id, 10)])
    .find((options) => options && options.length)

  if (roomOptions && roomOptions.length) {
    const displayedRoomOptions = getRoomOptionsForDisplay(slotTheme || roomId, roomOptions, getSlotReservationDate(slot), roomIdsByTheme)
    if (displayedRoomOptions.length) return displayedRoomOptions
  }

  return []
}

const parseReservationDate = (date) => {
  if (!date) return false

  if (date instanceof Date) {
    return Number.isNaN(date.getTime()) ? null : date
  }

  const rawDate = `${date}`.trim()
  const isoMatch = rawDate.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
  if (isoMatch) {
    return new Date(parseInt(isoMatch[1], 10), parseInt(isoMatch[2], 10) - 1, parseInt(isoMatch[3], 10))
  }

  const frMatch = rawDate.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/)
  if (frMatch) {
    return new Date(parseInt(frMatch[3], 10), parseInt(frMatch[2], 10) - 1, parseInt(frMatch[1], 10))
  }

  const parsedDate = new Date(rawDate)
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
}

const isMoreThanThreeDaysAway = (date) => {
  const parsedReservationDate = parseReservationDate(date)
  if (!parsedReservationDate) return true

  const reservationDate = new Date(
    parsedReservationDate.getFullYear(),
    parsedReservationDate.getMonth(),
    parsedReservationDate.getDate()
  )

  const threeDaysFromNow = new Date()
  threeDaysFromNow.setHours(0, 0, 0, 0)
  threeDaysFromNow.setDate(threeDaysFromNow.getDate() + 3)

  return reservationDate > threeDaysFromNow
}

const getOptionTypeSortRank = (optionType) => {
  if (optionType === 'video') return 0
  if (optionType === 'birthday') return 1
  if (optionType === 'vbn') return 2
  return 3
}

const getOptionDisplayComparableId = (option) => {
  const numericId = parseInt(option.id, 10)
  return Number.isNaN(numericId) ? `${option.id}` : numericId
}

const sortDisplayedOptions = (options) => {
  return options
    .slice()
    .sort((optionA, optionB) => {
      const optionAType = getOptionTypeSortRank(optionA.type)
      const optionBType = getOptionTypeSortRank(optionB.type)
      if (optionAType !== optionBType) return optionAType - optionBType

      const optionAId = getOptionDisplayComparableId(optionA)
      const optionBId = getOptionDisplayComparableId(optionB)
      if (optionAId === optionBId) return 0
      if (typeof optionAId === 'number' && typeof optionBId === 'number') return optionAId - optionBId
      return `${optionAId}`.localeCompare(`${optionBId}`)
    })
}

class ThemesCart extends Component {
  constructor(props) {
    super(props)

    const selectedOptionIds = getSlotSelectedOptionIds(props.slot)
    this.state = {
      hasOption: selectedOptionIds.length > 0,
      totalPrice: 0,
      selectedOptionId: selectedOptionIds[0] || null,
      selectedOptionIds: selectedOptionIds,
      birthdayFirstname: getBirthdayFirstnameFromComment(props.slot && props.slot.comment),
      birthdayError: false,
      birthdayOptionOpenId: null,
      showBirthdayPopIn: false,
      preservedOptions: [],
      fetchedOptions: []
    }
    this.optionRequest = Promise.resolve()
  }

  formatLanguage = (lang) => {
    switch (lang) {
      case 'french':
        return 'Fr'
      case 'english':
        return 'En'
      default:
        break
    }
  }

  formatDate = (date, slot) => {
    if (slot) {
      const slotHour = slot.split(":")[0]
      const slotMinutes = slot.split(":")[1]
      if (this.props.lang === "fr") {
        return `${formatDateWithZero(date)}, à ${slotHour}h${slotMinutes}`
      } else {
        return `${formatDateWithZero(date)}, ${slotHour}h${slotMinutes}`
      }
    }
  }

  getThemeByRoomId = (roomId) => {
    return getThemeFromRoomId(roomId, this.props.roomIdsByTheme || {})
  }

  getThemeForSlot = (slot) => {
    return getSlotTheme(slot, this.props.roomIdsByTheme || {})
  }

  getStreetAddress = (room) => {
    const theme = normalizeTheme(room) || this.getThemeByRoomId(room)
    switch (theme) {
      case 'la':
      case 'vbn':
        return "24 rue Emile Lepeu 75011 PARIS"
      case 'abattoir':
      case 'yakuza':
      case 'tombeau':
        return "23 rue Servan 75011 PARIS"
      default:
        break
    }
  }

  toggleOption = async (displayedOption, resaId, resaToken, hasOption) => {
    const optionId = displayedOption
      ? (displayedOption.id || displayedOption.id_room_option || displayedOption.room_option_id)
      : null
    if (!hasOption && !optionId) {
      return
    }

    const optionType = displayedOption ? displayedOption.type : ''
    const birthdayFirstname = this.state.birthdayFirstname.trim()
    const previousHasOption = this.state.hasOption
    const previousTotalPrice = this.state.totalPrice
    const previousBirthdayError = this.state.birthdayError
    const previousSelectedOptionId = this.state.selectedOptionId
    const previousSelectedOptionIds = this.state.selectedOptionIds || []
    const previousPreservedOptions = this.state.preservedOptions || []
    const previousBirthdayOptionOpenId = this.state.birthdayOptionOpenId
    const numericOptionPrice = parseFloat(displayedOption && displayedOption.price ? displayedOption.price : 0)
    const nextSelectedOptionIds = hasOption
      ? previousSelectedOptionIds.filter((id) => `${id}` !== `${optionId}`)
      : previousSelectedOptionIds.concat(`${optionId}`)
    const optimisticTotalPrice = hasOption
      ? previousTotalPrice - numericOptionPrice
      : previousTotalPrice + numericOptionPrice
    const nextPreservedOptions = hasOption
      ? previousPreservedOptions.filter((option) => `${option.id}` !== `${optionId}`)
      : previousPreservedOptions.some((option) => `${option.id}` === `${optionId}`)
        ? previousPreservedOptions
        : previousPreservedOptions.concat(displayedOption)
    this.setState({
      hasOption: nextSelectedOptionIds.length > 0,
      totalPrice: optimisticTotalPrice,
      selectedOptionId: nextSelectedOptionIds[0] || null,
      selectedOptionIds: nextSelectedOptionIds,
      birthdayError: false,
      birthdayOptionOpenId: hasOption ? null : previousBirthdayOptionOpenId,
      birthdayFirstname: hasOption && optionType === 'birthday' ? '' : this.state.birthdayFirstname,
      preservedOptions: nextPreservedOptions
    })

    let body = {
      id_reservation: resaId,
      token_reservation: this.findToken(resaId) || resaToken,
      // VBN option IDs can differ between local and production catalogs.
      // Let the API resolve the active option from the reservation and type.
      id_room_option: optionType === 'vbn' ? '' : optionId,
      option_type: optionType
    }
    if (!hasOption && optionType === 'birthday') {
      body.option_person_firstname = birthdayFirstname
    }

    const url = hasOption ? `${API_ROOT}FrontDeleteOptionFromReservation.php` : `${API_ROOT}FrontAddOptionToReservation.php`

    const runRequest = async () => {
      let lastError
      for (let attempt = 0; attempt < 3; attempt += 1) {
        try {
          const response = await fetch(url, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            method: 'post',
            body: buildFormBody(body)
          })
          const responseText = await response.text()
          let data
          try {
            data = JSON.parse(responseText.replace(/^\uFEFF/, ''))
          } catch (parseError) {
            throw new Error(`Réponse invalide du serveur (${response.status})`)
          }
          if (!response.ok) {
            throw new Error(data && data.message ? data.message : `Erreur serveur (${response.status})`)
          }
          return data
        } catch (error) {
          lastError = error
          if (attempt < 2) {
            await new Promise(resolve => setTimeout(resolve, 350 * (attempt + 1)))
          }
        }
      }
      throw lastError
    }

    this.optionRequest = this.optionRequest.then(runRequest, runRequest)
      .then(data => {
        if (!data || data.result === false) {
          throw new Error(data && data.message ? data.message : "L'ajout de l'option a échoué")
        }
        if (Array.isArray(data.rooms)) {
          this.props.updateBookings(data)
        }
        const updatedRoom = Array.isArray(data.rooms)
          ? data.rooms.filter(x => `${x.id}` === `${resaId}`).shift()
          : null
        const serverSelectedOptionIds = updatedRoom
          ? getSlotSelectedOptionIds(updatedRoom)
          : nextSelectedOptionIds
        const effectiveSelectedOptionIds = hasOption
          ? serverSelectedOptionIds
          : Array.from(new Set(serverSelectedOptionIds.concat(nextSelectedOptionIds)))
        const totalPrice = updatedRoom ? updatedRoom.price_reservation_total_without_promo : optimisticTotalPrice

        // Keep selected options in the cart cookie even when the API response
        // contains rooms without their room_options payload.
        const cookies = new Cookies()
        const bookings = cookies.get('bookings') || []
        let persistedOptionsForReservation = []
        const updatedBookings = bookings.map((booking) => {
          if (`${booking.id}` !== `${resaId}` && `${booking.id_room_reservation}` !== `${resaId}`) {
            return booking
          }

          const bookingOptions = getSlotSelectedOptions(booking)
          const fallbackOptions = getSlotSelectedOptions(this.props.slot)
          const selectedOptions = bookingOptions.concat(fallbackOptions)
            .filter((option, index, options) => option && options.findIndex(candidate => `${candidate.id}` === `${option.id}`) === index)
          const normalizedOptionToAdd = normalizeSelectedRoomOption(displayedOption)
          const optionToAdd = optionType === 'birthday'
            ? {
                ...normalizedOptionToAdd,
                option_person_firstname: birthdayFirstname,
                person_firstname: birthdayFirstname
              }
            : normalizedOptionToAdd
          const nextOptions = hasOption
            ? selectedOptions.filter((option) => `${option.id}` !== `${optionId}`)
            : selectedOptions.concat(optionToAdd).filter((option, index, options) => option && options.findIndex(candidate => `${candidate.id}` === `${option.id}`) === index)
          const nextOption = nextOptions[0] || null
          persistedOptionsForReservation = nextOptions

          return {
            ...booking,
            room_options: nextOptions,
            id_room_option: nextOption ? nextOption.id : '',
            room_option_name: nextOption ? nextOption.name : '',
            room_option_description: nextOption ? nextOption.description : '',
            room_option_price: nextOption ? nextOption.price : 0,
            room_option_price_without_promo: nextOption ? nextOption.price : 0,
            price_reservation_total: totalPrice,
            price_reservation_total_without_promo: totalPrice
          }
        })
        cookies.set('bookings', safeBookingsForCookie(updatedBookings), cartCookieOptions())
        const optionStates = cookies.get('bookingOptionStates') || {}
        optionStates[`${resaId}`] = {
          room_options: persistedOptionsForReservation,
          price_reservation_total: totalPrice,
          price_reservation_total_without_promo: totalPrice
        }
        cookies.set('bookingOptionStates', optionStates, cartCookieOptions())

        this.setState({
          totalPrice: totalPrice,
          hasOption: effectiveSelectedOptionIds.length > 0,
          selectedOptionId: effectiveSelectedOptionIds[0] || null,
          selectedOptionIds: effectiveSelectedOptionIds,
          birthdayOptionOpenId: null,
          showBirthdayPopIn: false,
          birthdayFirstname: hasOption ? '' : birthdayFirstname
        })
        if (this.props.closeOptionPopIns) this.props.closeOptionPopIns()
      })
      .catch(error => {
        console.log(error)
        this.setState({
          hasOption: previousHasOption,
          totalPrice: previousTotalPrice,
          selectedOptionId: previousSelectedOptionId,
          selectedOptionIds: previousSelectedOptionIds,
          preservedOptions: previousPreservedOptions,
          birthdayError: previousBirthdayError,
          birthdayOptionOpenId: previousBirthdayOptionOpenId
        })
      })

    return this.optionRequest
  }

  submitBirthdayOption = (displayedOption, slot) => {
    if (!displayedOption || displayedOption.type !== 'birthday') return

    const selectedOptionIds = this.state.selectedOptionIds || []
    const optionIsSelected = selectedOptionIds.indexOf(`${displayedOption.id}`) !== -1

    if (optionIsSelected) return

    this.toggleOption(displayedOption, slot.id, slot.id_room_reservation_token, false)
  }

  setTotalPrice = (slot) => {
    let totalPrice
    if (hasSelectedRoomOption(slot)) {
      totalPrice = slot.price_reservation_total
    } else {
      totalPrice = slot.price_reservation_total_without_promo
    }
    this.setState({ totalPrice: totalPrice })
  }

  getBookingInfo = async (idOrder, tokenOrder) => {
    return await axios.get(buildAPI_URL_Booking(idOrder, tokenOrder))
      .then(response => {
        const booking = response.data
        const selectedOptionIds = getSlotSelectedOptionIds(booking)
        this.setState({
          totalPrice: booking.order_item_price,
          hasOption: selectedOptionIds.length > 0,
          selectedOptionId: selectedOptionIds[0] || null,
          selectedOptionIds: selectedOptionIds,
          birthdayFirstname: getBirthdayFirstnameFromComment(booking && booking.comment)
        })
      })
      .catch(error => console.log(error))
  }

  findToken = (id) => {
    const cookies = new Cookies()
    const bookingsTokens = cookies.get("bookingsTokens") || []
    const token = bookingsTokens.filter(x => `${x.id_room_reservation}` === `${id}`).shift()
    if (token && token.id_room_reservation_token) {
      return token.id_room_reservation_token
    }

    const bookings = cookies.get("bookings") || []
    const booking = bookings.filter(x => `${x.id}` === `${id}`).shift()
    return booking ? booking.id_room_reservation_token : ''
  }

  componentDidMount() {
    this.setTotalPrice(this.props.slot)
    this.loadAvailableOptions()

    if (hasSelectedRoomOption(this.props.slot)) {
      const selectedOptionIds = getSlotSelectedOptionIds(this.props.slot)
      this.setState({ hasOption: selectedOptionIds.length > 0, selectedOptionId: selectedOptionIds[0] || null, selectedOptionIds: selectedOptionIds })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.roomOptionsByRoom !== this.props.roomOptionsByRoom
      || prevProps.roomIdsByTheme !== this.props.roomIdsByTheme) {
      this.loadAvailableOptions()
    }
    if (prevProps.slot === this.props.slot) return

    const selectedOptionIds = getSlotSelectedOptionIds(this.props.slot)
    const birthdayFirstname = getBirthdayFirstnameFromComment(this.props.slot && this.props.slot.comment)
    this.setState((state) => {
      if (state.selectedOptionIds.length === selectedOptionIds.length
        && state.selectedOptionIds.every((id) => selectedOptionIds.indexOf(id) !== -1)) {
        return null
      }
      return {
        hasOption: selectedOptionIds.length > 0,
        selectedOptionId: selectedOptionIds[0] || null,
        selectedOptionIds: selectedOptionIds,
        birthdayFirstname: birthdayFirstname || state.birthdayFirstname,
        totalPrice: this.props.slot ? this.props.slot.price_reservation_total_without_promo : state.totalPrice
      }
    })
  }

  loadAvailableOptions = async () => {
    const optionsByRoom = this.props.roomOptionsByRoom || {}
    const currentOptions = getOptionsForSlot(this.props.slot, optionsByRoom, this.props.roomIdsByTheme)
    if (currentOptions.length > 0) {
      if (this.state.fetchedOptions.length > 0) this.setState({ fetchedOptions: [] })
      return
    }

    const slotTheme = getSlotTheme(this.props.slot, this.props.roomIdsByTheme)
    if (!slotTheme) return

    for (const companyId of ['30', '1']) {
      try {
        const response = await axios.get(`${API_ROOT}FrontGetInfosRoomPricingByCompany.php?id_company=${companyId}`)
        const rooms = response.data && Array.isArray(response.data.rooms) ? response.data.rooms : []
        const room = rooms.find((candidate) => {
          const roomName = `${candidate.room_name || ''} ${candidate.roomname || ''} ${candidate.enigma_name || ''} ${candidate.name || ''}`
          return getThemeFromRoomName(roomName) === slotTheme
        })
        if (!room) continue

        const options = getRoomOptionsForDisplay(slotTheme, room.options || [], getSlotReservationDate(this.props.slot), this.props.roomIdsByTheme)
        this.setState({ fetchedOptions: options })
        return
      } catch (error) {
        console.log(error)
      }
    }
  }

  getAvailableOptions = () => {
    const optionsByRoom = this.props.roomOptionsByRoom || {}
    const slotTheme = this.getThemeForSlot(this.props.slot)
    const roomId = getResolvedSlotRoomId(this.props.slot, this.props.roomIdsByTheme)
    const roomOptions = getOptionsForSlot(this.props.slot, optionsByRoom, this.props.roomIdsByTheme)

    const availableOptions = getRoomOptionsForDisplay(slotTheme || roomId, roomOptions, getSlotReservationDate(this.props.slot), this.props.roomIdsByTheme)
    return availableOptions.length > 0 ? availableOptions : this.state.fetchedOptions
  }

  getOptionConfig = (optionType) => {
    switch (optionType) {
      case 'video':
        return {
          title: messages.videoPackTitle,
          note: messages.videoPackNote,
          add: messages.addVideoPack,
          delete: messages.deleteVideoPack,
          icon: "video",
          className: "themes-cart-option--video-pack"
        }
      case 'birthday':
        return {
          title: messages.birthdayTitle,
          note: messages.birthdayNote,
          add: messages.addBirthday,
          delete: messages.deleteBirthday,
          icon: "birthday-cake",
          className: "themes-cart-option--birthday"
        }
      default:
        return {
          title: messages.customizationTitle,
          note: null,
          add: messages.addCustomization,
          delete: messages.deleteCustomization,
          icon: "vbn",
          className: "themes-cart-option--vbn"
        }
    }
  }

  getOptionConfigForRoom = (optionType, roomId) => {
    const config = this.getOptionConfig(optionType)
    const roomTheme = getThemeFromRoomId(roomId, this.props.roomIdsByTheme) || roomId
    if (optionType === 'video' && roomTheme === 'abattoir') {
      return {
        ...config,
        title: messages.videoPackAbattoirTitle
      }
    }
    if (optionType === 'video' && roomTheme === 'tombeau') {
      return {
        ...config,
        title: messages.videoPackExpeditionTitle
      }
    }
    if (optionType !== 'birthday') return config

    const variant = getBirthdayOptionVariant(roomId, this.props.roomIdsByTheme)
    return {
      ...config,
      className: `${config.className} themes-cart-option--birthday-${variant}`,
      iconClassName: `themes-cart-option-icon--birthday-${variant}`
    }
  }

  getDisplayedOptions = () => {
    const slot = this.props.slot
    const slotTheme = this.getThemeForSlot(slot)
    const roomId = getResolvedSlotRoomId(slot, this.props.roomIdsByTheme) || slotTheme
    const availableOptions = this.getAvailableOptions().map((option) => {
      const normalizedOption = normalizeSelectedRoomOption(option) || option
      const optionId = normalizedOption.id || normalizedOption.id_room_option || normalizedOption.room_option_id
      if (!optionId) return null
      const optionType = getOptionType(normalizedOption, roomId, this.props.roomIdsByTheme)
      const fallbackPrice = optionType === 'video' ? 20 : optionType === 'birthday' ? 15 : 50
      return {
        ...normalizedOption,
        id: optionId,
        type: optionType,
        config: this.getOptionConfigForRoom(optionType, roomId),
        price: getOptionPrice(fallbackPrice, [normalizedOption.price])
      }
    }).filter((option) => option && option.type && option.id)
    const availableOptionIds = new Set(availableOptions.map((option) => `${option.id}`))
    const preservedOptions = (this.state.preservedOptions || [])
      .filter((option) => option && option.id && !availableOptionIds.has(`${option.id}`))
    const sortedAvailableOptions = sortDisplayedOptions(availableOptions.concat(preservedOptions))

    const selectedOptions = getSlotSelectedOptions(slot).map((selectedRoomOption) => {
      const optionType = getOptionType(selectedRoomOption, roomId, this.props.roomIdsByTheme)
      if (!optionType) return null
      const fallbackPrice = optionType === 'video' ? 20 : optionType === 'birthday' ? 15 : 50
      return {
        ...selectedRoomOption,
        id: selectedRoomOption.id || null,
        name: selectedRoomOption.name || selectedRoomOption.room_option_name,
        type: optionType,
        config: this.getOptionConfigForRoom(optionType, roomId),
        price: getOptionPrice(fallbackPrice, [
          selectedRoomOption.price,
          selectedRoomOption.room_option_price_without_promo,
          selectedRoomOption.room_option_price
        ])
      }
    }).filter((option) => option && option.id && option.config)

    const optionsToMerge = selectedOptions.concat(sortedAvailableOptions, preservedOptions)
    const deduplicatedOptions = []
    const seenOptionIds = new Set()
    optionsToMerge.forEach((option) => {
      const optionId = `${option.id}`
      if (seenOptionIds.has(optionId)) return
      seenOptionIds.add(optionId)
      deduplicatedOptions.push(option)
    })

    return sortDisplayedOptions(deduplicatedOptions)
  }

  getDisplayedTotalPrice = (displayedOptions) => {
    const slot = this.props.slot
    const reservationPrice = toPriceNumber(slot.reservation_price_without_promo || slot.reservation_price)
    const selectedOptionIds = this.state.selectedOptionIds || []
    const optionPrice = this.state.hasOption
      ? displayedOptions
        .filter((option) => selectedOptionIds.indexOf(`${option.id}`) !== -1)
        .reduce((total, option) => total + toPriceNumber(option.price), 0)
      : 0

    return reservationPrice + optionPrice
  }

  render() {
    const slot = this.props.slot
    const roomId = getResolvedSlotRoomId(slot, this.props.roomIdsByTheme)
    const {intl:{formatMessage}} = this.props
    const theme = this.getThemeForSlot(slot) || this.getThemeByRoomId(roomId)
    const fallbackThemeName = getSlotFallbackName(slot)
    const inferredTheme = theme
      || getThemeFromRoomId(roomId, this.props.roomIdsByTheme || {})
      || getThemeFromRoomName(`${slot.room || ''} ${fallbackThemeName}`)
    const displayedOptions = this.getDisplayedOptions()
    const displayedTotalPrice = formatPrice(this.getDisplayedTotalPrice(displayedOptions))
    const themeCodeConverter = (themeCode) => {
      switch (themeCode) {
        case 'la':
          return formatMessage(messages.la)
        case 'vbn':
          return formatMessage(messages.VBN)
        case 'abattoir':
          return formatMessage(messages.slaughterhouse)
        case 'yakuza':
          return formatMessage(messages.yakuza)
        case 'tombeau':
          return formatMessage(messages.tombeau)
        default:
          break
      }
    }
    const themeName = themeCodeConverter(inferredTheme) || fallbackThemeName || themeCodeConverter(getThemeFromRoomName(slot.room)) || ''
    const themeIcon = themeIconConverter(inferredTheme)
    return (
      <div
        className={displayedOptions.length > 0 ? "themes-cart themes-cart--with-option" : "themes-cart"}>
        <div className="themes-cart-header">
          <div className="themes-cart-header-title">
            {themeIcon ? <img src={themeIcon} className="themes-cart-icon" alt=""/> : null}
            <div className="themes-cart-title">{themeName}</div>
          </div>
          <div className="themes-cart-action-container">
            <div
              onClick={() => this.props.editCartItem(slot)}
              className="themes-cart-action themes-cart-edit">
              <img src={EditIcon} alt="edit" />
              <span>{formatMessage(messages.edit)}</span>
            </div>
            <div
              onClick={() => this.props.deleteCartItem(slot)}
              className="themes-cart-action themes-cart-delete">
              <img src={DeleteIcon} alt="delete" />
              <span>{formatMessage(messages.delete)}</span>
            </div>
          </div>
        </div>
        <div className="themes-cart-content">
          <ul className="themes-cart-info">
            <li>
              <img src={MarkerIcon} alt="marker"/>
              <span className="themes-cart-info-title">{formatMessage(messages.place)} </span>
              <span>{this.getStreetAddress(inferredTheme || roomId)}</span>
            </li>
            <li>
              <img src={CalendarIcon} alt="calendar" width={17} height={19}/>
              <span className="themes-cart-info-title">{formatMessage(messages.date)} </span>
              <span>{this.formatDate(slot.reservation_date, slot.time_begin)}</span>
            </li>
            <div className="themes-cart-info-row">
              <li>
                <img src={PlayerIcon} alt="players"/>
                <span className="themes-cart-info-title">{formatMessage(messages.players)} </span>
                <span>{slot.quantity_player}</span>
              </li>
              <li>
                <img src={GlobeIcon} alt="language"/>
                <span className="themes-cart-info-title">{formatMessage(messages.language)} </span>
                <span>{slot.lang}</span>
              </li>
            </div>
            <li className="themes-cart-price">{displayedTotalPrice.euros},<sup>{displayedTotalPrice.cents}</sup>€</li>
          </ul>
        </div>
          {
            displayedOptions.length > 0
              ?
              <div className="themes-cart-options">
              {displayedOptions.map((displayedOption) => {
                const displayedOptionPrice = formatPrice(displayedOption.price)
                const optionConfig = displayedOption.config
                const optionIsSelected = this.state.hasOption && (this.state.selectedOptionIds || []).indexOf(`${displayedOption.id}`) !== -1
                const birthdayInputOpen = !optionIsSelected
                  && displayedOption.type === "birthday"
                  && `${this.state.birthdayOptionOpenId}` === `${displayedOption.id}`
                const optionCtaLabel = optionIsSelected
                  ? formatMessage(optionConfig.delete)
                  : birthdayInputOpen
                    ? formatMessage(optionConfig.delete)
                    : displayedOption.type === "video" || displayedOption.type === "birthday"
                      ? `${formatMessage(optionConfig.add)} ${displayedOptionPrice.euros},${displayedOptionPrice.cents}€`
                      : formatMessage(optionConfig.add)
                const selectedBirthdayFirstname = displayedOption.option_person_firstname
                  || displayedOption.person_firstname
                  || displayedOption.firstname
                  || (optionIsSelected && displayedOption.type === 'birthday' ? this.state.birthdayFirstname : '')
                return (
               <div className={[
                 "themes-cart-option",
                 optionConfig.className,
                 optionIsSelected ? "themes-cart-option--active" : "",
                 birthdayInputOpen ? "themes-cart-option--editing" : ""
               ].join(" ")} key={displayedOption.id || displayedOption.type}>
                 <div className="themes-cart-option-content">
                   {
                    optionConfig.icon === "vbn"
                    ? <img src={CupCake} alt="" className="themes-cart-option-icon themes-cart-option-icon--vbn" />
                    : optionConfig.icon === "birthday-cake"
                      ? <img src={BirthdayCake} alt="" className="themes-cart-option-icon" />
                    : <span className={[
                        "themes-cart-option-icon",
                        optionConfig.icon === "video" ? "themes-cart-option-icon--video" : "themes-cart-option-icon--birthday",
                        optionConfig.iconClassName || ""
                   ].join(" ")} aria-hidden="true"></span>
                   }
                   <div className="themes-cart-option-text">
                      <div className="themes-cart-option-text-container themes-cart-option-title-row">
                        <h4>{formatMessage(optionConfig.title)}</h4>
                        {
                          (displayedOption.type === "video" || displayedOption.type === "birthday") && !optionIsSelected
                          ? null
                          : <p className="themes-cart-option-inline-price">{displayedOptionPrice.euros},<sup>{displayedOptionPrice.cents}</sup>€</p>
                        }
                      </div>
                      {optionIsSelected && displayedOption.type === 'birthday' && selectedBirthdayFirstname
                        ? <p className="themes-cart-option-selected-detail">Prénom : {selectedBirthdayFirstname}</p>
                        : null}
                      {optionIsSelected && displayedOption.type === 'video'
                        ? <p className="themes-cart-option-selected-detail themes-cart-option-video-detail">
                            Montage vidéo souvenir de la session, envoyé par email après la partie.
                          </p>
                        : null}
                      {!optionIsSelected && displayedOption.type === 'video'
                        ? <p className="themes-cart-option-note">{formatMessage(optionConfig.note)}</p>
                        : null}
                      <p className="themes-cart-option-more">
                       {
                        displayedOption.type === "vbn"
                        ? <span className="customization-learn-more customization-learn-more--booking" onClick={() => this.props.togglePopInVBNCustom()}>{formatMessage(messages.customizationLearnMore)}</span>
                        : displayedOption.type === "video"
                          ? <span className="customization-learn-more customization-learn-more--booking" onClick={() => this.props.togglePopInVideoPack()}>{formatMessage(messages.customizationLearnMore)}</span>
                          : <span className="customization-learn-more customization-learn-more--booking" onClick={() => this.setState({ showBirthdayPopIn: true })}>{formatMessage(messages.customizationLearnMore)}</span>
                       }
                       <span className="themes-cart-option-more-info">
                       </span>
                     </p>
                   </div>
                  </div>
                  {
                    birthdayInputOpen
                    ? <div className="themes-cart-option-field themes-cart-option-field--aligned">
                        <input
                          type="text"
                          autoFocus
                          value={this.state.birthdayFirstname}
                          onChange={(event) => this.setState({ birthdayFirstname: event.target.value, birthdayError: false })}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                              event.preventDefault()
                              this.submitBirthdayOption(displayedOption, slot)
                            }
                          }}
                          placeholder={formatMessage(messages.birthdayFirstnamePlaceholder)}
                        />
                        <button
                          type="button"
                          className="themes-cart-option-validate"
                          onClick={() => this.submitBirthdayOption(displayedOption, slot)}
                        >
                          {formatMessage(messages.validateBirthdayFirstname)}
                        </button>
                        {this.state.birthdayError ? <span>{formatMessage(messages.birthdayFirstnameError)}</span> : null}
                      </div>
                    : null
                  }
                  <div className="themes-cart-option-side">
                    <div onClick={() => optionIsSelected
                      ? this.toggleOption(displayedOption, slot.id, slot.id_room_reservation_token, true)
                      : birthdayInputOpen
                        ? this.setState({ birthdayOptionOpenId: null, birthdayError: false, birthdayFirstname: '' })
                      : displayedOption.type === 'birthday'
                        ? this.toggleOption(displayedOption, slot.id, slot.id_room_reservation_token, false)
                        : this.toggleOption(displayedOption, slot.id, slot.id_room_reservation_token, false)
                    } className={`themes-cart-option-cta${optionIsSelected ? ' themes-cart-option-cta--remove' : ''}`}>
                     <span>
                       {optionCtaLabel}
                     </span>
                   </div>
                 </div>
               </div>
              )})}
              </div>
              : null
          }

        {
          this.state.showBirthdayPopIn
          ? <PopIn
            closePopIn={() => this.setState({ showBirthdayPopIn: false })}
            title={formatMessage(messages.birthdayTitle)}
            klass="pop-in-inner--birthday"
          >
              <div className="pop-in-birthday-option">
                <p className="pop-in-birthday-lead">{formatMessage(messages.birthdayPopInBaseline)}</p>
                <div className="pop-in-birthday-points">
                  <div>
                    <strong>{formatMessage(messages.birthdayPopInContentTitle)}</strong>
                    <span>{formatMessage(messages.birthdayPopInContent1)}</span>
                  </div>
                </div>
                <p className="pop-in-birthday-note">{formatMessage(messages.birthdayPopInContent4)}</p>
              </div>
            </PopIn>
          : null
        }
      </div>
    )
  }
}

const messages = defineMessages({
  la: {
    id: 'themes.la',
    defaultMessage: 'Lost Asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Mission Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  place: {
    id: 'themesCart.place',
    defaultMessage: "Lieu :"
  },
  date: {
    id: 'themesCart.date',
    defaultMessage: "Date :"
  },
  players: {
    id: 'themesCart.players',
    defaultMessage: "Joueurs :"
  },
  language: {
    id: 'themesCart.language',
    defaultMessage: "Langue :"
  },
  edit: {
    id: 'themesCart.edit',
    defaultMessage: "Modifier"
  },
  delete: {
    id: 'themesCart.delete',
    defaultMessage: "Effacer"
  },
  customizationTitle: {
    id: 'themesCart.customizationTitle',
    defaultMessage: "Option de personnalisation"
  },
  customizationNote: {
    id: 'themesCart.customizationNote',
    defaultMessage: ""
  },
  customizationLearnMore: {
    id: 'themesCart.customizationLearnMore',
    defaultMessage: "En savoir plus"
  },
  addCustomization: {
    id: 'themesCart.addCustomization',
    defaultMessage: "Ajouter cette option"
  },
  deleteCustomization: {
    id: 'themesCart.deleteCustomization',
    defaultMessage: "Supprimer l'option"
  },
  videoPackTitle: {
    id: 'themesCart.videoPackTitle',
    defaultMessage: 'Pack vidéo "Lost Asylum"'
  },
  videoPackAbattoirTitle: {
    id: 'themesCart.videoPackAbattoirTitle',
    defaultMessage: 'Pack vidéo "L\'Abattoir"'
  },
  videoPackExpeditionTitle: {
    id: 'themesCart.videoPackExpeditionTitle',
    defaultMessage: "Gardez un souvenir vidéo de L'Expédition Maudite"
  },
  videoPackNote: {
    id: 'themesCart.videoPackNote',
    defaultMessage: "Recevez le montage souvenir de votre session."
  },
  addVideoPack: {
    id: 'themesCart.addVideoPack',
    defaultMessage: "Ajouter le pack vidéo"
  },
  deleteVideoPack: {
    id: 'themesCart.deleteVideoPack',
    defaultMessage: "Supprimer l'option"
  },
  birthdayTitle: {
    id: 'themesCart.birthdayTitle',
    defaultMessage: "Option anniversaire"
  },
  birthdayNote: {
    id: 'themesCart.birthdayNote',
    defaultMessage: "Ajoutez une surprise dédiée à la personne fêtée."
  },
  addBirthday: {
    id: 'themesCart.addBirthday',
    defaultMessage: "Ajouter l'option"
  },
  validateBirthday: {
    id: 'themesCart.validateBirthday',
    defaultMessage: "Valider l'option"
  },
  validateBirthdayFirstname: {
    id: 'themesCart.validateBirthdayFirstname',
    defaultMessage: "Valider le prénom"
  },
  deleteBirthday: {
    id: 'themesCart.deleteBirthday',
    defaultMessage: "Supprimer l'option"
  },
  birthdayFirstnamePlaceholder: {
    id: 'themesCart.birthdayFirstnamePlaceholder',
    defaultMessage: "Prénom de la personne fêtée"
  },
  birthdayFirstnameError: {
    id: 'themesCart.birthdayFirstnameError',
    defaultMessage: "Indiquez le prénom pour préparer la surprise."
  },
  birthdayPopInBaseline: {
    id: 'themesCart.birthdayPopInBaseline',
    defaultMessage: 'Pour 15 €, ajoutez une surprise intégrée à votre partie.'
  },
  birthdayPopInContentTitle: {
    id: 'themesCart.birthdayPopInContentTitle',
    defaultMessage: "Une séquence horrifique rien que pour elle"
  },
  birthdayPopInContent1: {
    id: 'themesCart.birthdayPopInContent1',
    defaultMessage: "La personne fêtée se retrouvera seule pendant une séquence horrifique spécialement conçue pour elle."
  },
  birthdayPopInContent2: {
    id: 'themesCart.birthdayPopInContent2',
    defaultMessage: "Sur Lost Asylum et L'Abattoir"
  },
  birthdayPopInContent3: {
    id: 'themesCart.birthdayPopInContent3',
    defaultMessage: "Indiquez simplement son prénom lorsque vous venez."
  },
  birthdayPopInContent4: {
    id: 'themesCart.birthdayPopInContent4',
    defaultMessage: "L'équipe prépare la surprise pour marquer le coup sans la dévoiler au reste du groupe."
  },
})

export default injectIntl(ThemesCart)



// WEBPACK FOOTER //
// ./src/components/ThemesCart.js